import React from 'react';
import {Linking, Modal, Platform, ScrollView, TouchableOpacity, View} from 'react-native';
import MainStyle from '../../MainStyle';
import {colors} from '../assets/styles/colors';
import Div from '../lib/Div';
import Button from './Button';
import {isFullSwing, WebApp} from "../constants";
import P from "../lib/P";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import Btn from "./Btn";

type Props = { isOpen: boolean, onClose: () => void };

const PromoFeedbackModal = (props: Props) => {
  const {isOpen, onClose} = props;

  const openLink = (url: string) => {
    if (Platform.OS === 'web') window.open(url, '_blank');
    else Linking.openURL(url).then();
  };

  return (
    <Modal animationType="fade" transparent visible={isOpen} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg={isFullSwing ? '#131314' : colors.settings_bg} w={isFullSwing ? 343 : 389}
                 h={isFullSwing ? undefined : 452} rounded={isFullSwing ? 16 : 20} overflow="hidden"
                 borderColor={isFullSwing ? undefined : colors.settings_border}
                 borderWidth={isFullSwing ? undefined : 1} pt={isFullSwing ? undefined : 46}
                 minH={isFullSwing ? undefined : 400} pb={isFullSwing ? undefined : 41}>
              {isFullSwing ? (
                <Div position="relative" bg="#252526" justifyContent="center">
                  <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Bonus Cash</P>
                  <FontAwesome5
                    name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                    onPress={onClose}
                  />
                </Div>
              ) : (
                <P ta="center" fs={26} mb={42} lh={26} fw="500">BONUS CASH</P>
              )}

              <Div w={isFullSwing ? 311 : 287} mx="auto" mt={isFullSwing ? 24 : 0}>
                <P ta="center" fs={isFullSwing ? 16 : 18} fw={isFullSwing ? undefined : '500'}
                   fontFamily={isFullSwing ? 'DavisSans-Regular' : undefined} mb={15}>
                  Bonus Cash reflects Free Play and other bonuses issued to the user.
                </P>

                <P ta="center" fs={isFullSwing ? 16 : 18} fw={isFullSwing ? undefined : '500'}
                   fontFamily={isFullSwing ? 'DavisSans-Regular' : undefined} mb={15}>
                  These may be subject to gameplay requirements, including turnover.
                </P>

                <P ta="center" fs={isFullSwing ? 16 : 18} fw={isFullSwing ? undefined : '500'}
                   fontFamily={isFullSwing ? 'DavisSans-Regular' : undefined}>
                  For more information, see:
                </P>

                <TouchableOpacity onPress={() => openLink(`${WebApp}/promotions`)}>
                  <P ta="center" fs={isFullSwing ? 16 : 18} fw={isFullSwing ? undefined : '500'}
                     color={isFullSwing ? 'white' : colors.newGreenText}
                     textDecorationLine={isFullSwing ? 'underline' : 'none'}>
                    {isFullSwing ? 'Terms and Conditions' : '”Promos Terms & Conditions”'}
                  </P>
                </TouchableOpacity>

                {isFullSwing ? (
                  <Btn bg="#3369FF" rounded={4} mb={24} onPress={onClose} mt={30}>
                    <P lh={56} ta="center" fontFamily="DavisSans-Medium">Close</P>
                  </Btn>
                ) : (
                  <Button
                    w={240} mt={33} mx="auto" color={colors.mainBackground} fontSize={22} fontWeight="600" text="OK"
                    onPress={onClose}
                  />
                )}
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default PromoFeedbackModal;
